import { render, staticRenderFns } from "./DynamicDataChooser.vue?vue&type=template&id=5f5b1215&"
import script from "./DynamicDataChooser.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataChooser.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataChooser.vue?vue&type=style&index=0&id=5f5b1215&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports